<template>
    <section
        v-editable="blok"
        class="featured-articles"
    >
        <KSectionHeader
            class="featured-articles__header"
            :eyebrow="blok.eyebrow"
            :text="blok.text"
            :align="blok.align || 'start'"
        >
            <template
                v-if="title"
                #title
            >
                <span v-html="title" />
            </template>
            <template
                v-if="blok.action_label && (blok.action_link?.url || blok.action_link?.email || blok.action_link?.cached_url || blok.action_link?.anchor)"
                #actions
            >
                <StoryblokSectionHeaderAction
                    :label="blok.action_label"
                    :link="blok.action_link"
                    placement="featured-articles"
                />
            </template>
        </KSectionHeader>

        <div class="featured-articles__grid">
            <featured-article
                v-for="item in blok.articles"
                :key="item._uid"
                :item="item"
                :story="stories?.[item.article]"
            />
        </div>
    </section>
</template>

<script setup>
import { KSectionHeader } from '@vemedia/karibu'
import renderHighlightedText from '~/helpers/renderHighlightedText'

const { blok } = defineProps(['blok'])

const title = computed(() => renderHighlightedText(blok.title))

// One batched request for the whole section instead of one per card — the
// per-card fan-out burst was enough to trip Storyblok's rate limit on a cold
// cache, silently blanking cards (see server/api/pages-by-uuids.js). The
// watch re-fetches when the editor adds/removes/repoints cards.
const uuids = computed(() => (blok.articles || []).map(item => item.article).filter(Boolean))

const { data: stories } = await useAsyncData(
    `featured-articles-${blok._uid}`,
    () => (uuids.value.length ? $fetch(`/api/pages-by-uuids?uuids=${uuids.value.join(',')}`) : {}),
    { watch: [uuids] },
)
</script>

<style lang="scss">
@use 'featured-articles';
</style>
